export default __webpack_public_path__ + "static/mockup-iphone-store@2x-d7b1c5a5d43a86dc834554c8b7df2c55.png";